module.exports = __webpack_public_path__ + "img/draw_temubox.eaa1832f.png";